import React from "react";

import {
  FieldErrorText,
  FieldLabel,
  FormField,
  FormSelect,
  PrimaryActionButton,
  SectionFormGrid,
} from "pages/app/workspace/sections/styles/workspace-section.styles";

type FollowAthleteFormProps = {
  athletes: any[];
  athleteError?: string;
  isSubmitting: boolean;
  onAthleteChange: (value: string) => void;
  onSubmit: () => void;
  selectedAthleteId: string;
};

export const FollowAthleteForm: React.FC<FollowAthleteFormProps> = ({
  athletes,
  athleteError,
  isSubmitting,
  onAthleteChange,
  onSubmit,
  selectedAthleteId,
}) => (
  <SectionFormGrid>
    <FormField>
      <FieldLabel>Athlete</FieldLabel>
      <FormSelect
        aria-invalid={Boolean(athleteError)}
        onChange={(event) => onAthleteChange(event.target.value)}
        value={selectedAthleteId}
      >
        <option value="">Select an athlete</option>
        {athletes.map((athlete: any) => (
          <option key={athlete.id} value={athlete.id}>
            {athlete.full_name}
          </option>
        ))}
      </FormSelect>
      {athleteError ? <FieldErrorText>{athleteError}</FieldErrorText> : null}
    </FormField>

    <PrimaryActionButton
      disabled={!selectedAthleteId || isSubmitting}
      onClick={onSubmit}
      type="button"
    >
      {isSubmitting ? "Following..." : "Follow athlete"}
    </PrimaryActionButton>
  </SectionFormGrid>
);
